export enum CommonActionTypes {
    UPDATE_SNACK_BAR_ERROR_MESSAGE = 'common/update_snack_bar_error_message',
}
